import { baseApi, client } from '../baseApi.ts';
import GetStylesResponse from '../response/GetStylesResponse.ts';
import GetStyleCategoriesResponse from '../response/GetStyleCategoriesResponse.ts';

export const styleEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getStyles: builder.query({
			// @ts-ignore
			queryFn: async ({
				page = 1,
				pageSize = 100,
				type,
			}: { page?: number; pageSize?: number; type?: string } = {}) => {
				try {
					const request = { page, page_size: pageSize, ...(type && { type }) };
					const response = await client.styles.list(request);
					const data = new GetStylesResponse(response?.data).formatStylesData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['Styles'],
		}),
		getStyleCategories: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.styles.categories();
					const data = new GetStyleCategoriesResponse(response?.data).formatCategoriesData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['StyleCategories'],
		}),
	}),
});
